export default __webpack_public_path__ + "static/media/Blacksulphur Pants.d71b8018.jpg";